// profileReducer.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  field1: '',
  // userListItemToBeChanged: {},
  // userListItemToBeAdded: {},
  emailExisted: false,
  usernameExisted: false,
  lastNameOverMaxLength: false,
  firstNameOverMaxLength: false,
  bookReadLogToBeCleared: 0,
};

const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    // setUserListItemToBeAdded(state, action) {
    //   state.userListItemToBeAdded = action.payload;
    // },    
    // setUserListItemToBeChanged(state, action) {
    //   state.userListItemToBeChanged = action.payload;
    // },
    setBookReadLogToBeCleared(state, action) {
      state.bookReadLogToBeCleared = action.payload;
    },
    setEmailExisted(state, action) {
      state.emailExisted = action.payload;
    },
    setUsernameExisted(state, action) {
      state.usernameExisted = action.payload;
    },
    setLastNameOverMaxLength(state, action) {
      state.lastNameOverMaxLength = action.payload;
    },
    setFirstNameOverMaxLength(state, action) {
      state.firstNameOverMaxLength = action.payload;
    },
    reset4Profile() {
      return initialState;
    },
  },
});

export const { setBookReadLogToBeCleared, setEmailExisted, setUsernameExisted, setLastNameOverMaxLength, setFirstNameOverMaxLength, reset4Profile } = profileSlice.actions;
export default profileSlice.reducer;
// const initialState = {
//   field1: '',

//   userListItemToBeChanged: {},

//   // lastName4Profile: '',
//   // lastNameError4Profile: false,
//   // lastNameErrorMessage4Profile: '',

//   // firstName4Profile: '',
//   // firstNameError4Profile: false,
//   // firstNameErrorMessage4Profile: '',

//   // ageRange4Profile: '00',
//   // ageRangeError4Profile: false,
//   // ageRangeErrorMessage4Profile: '',

//   // gender4Profile: 'M',
//   // genderError4Profile: false,
//   // genderErrorMessage4Profile: '',

//   // country4Profile: '00',
//   // countryError4Profile: false,
//   // countryErrorMessage4Profile: '',

//   // email4Profile: '',
//   // emailError4Profile: false,
//   // emailErrorMessage4Profile: '',

//   // username4Profile: '',
//   // usernameError4Profile: false,
//   // usernameErrorMessage4Profile: '',

//   // password4Profile: '',
//   // passwordError4Profile: false,
//   // passwordErrorMessage4Profile: '',

//   // passwordRetype4Profile: '',
//   // passwordRetypeError4Profile: false,
//   // passwordRetypeErrorMessage4Profile: '',

//   emailExisted: false,
//   usernameExisted: false,
//   lastNameOverMaxLength: false,
//   firstNameOverMaxLength: false,
//   bookReadLogToBeCleared: 0,
// };

// export default function profileReducer(state = initialState, action) {

//   switch (action.type) {

//     case 'setUserListItemToBeChanged':
//       return {
//         ...state,
//         userListItemToBeChanged: action.payload,
//       };

//     // case 'updateField':
//     //   const { fieldName, value } = action.payload;
//     //   state[fieldName] = value; // Dynamically update the field value      
//     //   return {
//     //     // ...state,
//     //     // field1: action.payload,
//     //   };

//     // case 'setField1':
//     //   return {
//     //     ...state,
//     //     field1: action.payload, // Update the selected book
//     //   };

//     // case 'setProfileToBeChanged':
//     //   return {
//     //     ...state,
//     //     profileToBeChanged: action.payload, // Update the selected book
//     //   };

//     // case 'setLastName4Profile':
//     //   return {
//     //     ...state,
//     //     lastName4Profile: action.payload, // Update the selected book
//     //   };
//     // case 'setLastNameError4Profile':
//     //   return {
//     //     ...state,
//     //     lastNameError4Profile: action.payload, // Update the selected book
//     //   };
//     // case 'setLastNameErrorMessage4Profile':
//     //   return {
//     //     ...state,
//     //     lastNameErrorMessage4Profile: action.payload, // Update the selected book
//     //   };

//     // case 'setFirstName4Profile':
//     //   return {
//     //     ...state,
//     //     firstName4Profile: action.payload, // Update the selected book
//     //   };
//     // case 'setFirstNameError4Profile':
//     //   return {
//     //     ...state,
//     //     firstNameError4Profile: action.payload, // Update the selected book
//     //   };
//     // case 'setFirstNameErrorMessage4Profile':
//     //   return {
//     //     ...state,
//     //     firstNameErrorMessage4Profile: action.payload, // Update the selected book
//     //   };

//     // case 'setAgeRange4Profile':
//     //   return {
//     //     ...state,
//     //     ageRange4Profile: action.payload, // Update the selected book
//     //   };
//     // case 'setAgeRangeError4Profile':
//     //   return {
//     //     ...state,
//     //     ageRangeError4Profile: action.payload, // Update the selected book
//     //   };                        
//     // case 'setAgeRangeErrorMessage4Profile':
//     //   return {
//     //     ...state,
//     //     ageRangeErrorMessage4Profile: action.payload, // Update the selected book
//     //   };   

//     // case 'setGender4Profile':
//     //   return {
//     //     ...state,
//     //     gender4Profile: action.payload, // Update the selected book
//     //   }; 
//     // case 'setGenderError4Profile':
//     //   return {
//     //     ...state,
//     //     genderError4Profile: action.payload, // Update the selected book
//     //   }; 
//     // case 'setGenderErrorMessage4Profile':
//     //   return {
//     //     ...state,
//     //     genderErrorMessage4Profile: action.payload, // Update the selected book
//     //   }; 

//     // case 'setCountry4Profile':
//     //   return {
//     //     ...state,
//     //     country4Profile: action.payload, // Update the selected book
//     //   };
//     // case 'setCountryError4Profile':
//     //   return {
//     //     ...state,
//     //     countryError4Profile: action.payload, // Update the selected book
//     //   };
//     // case 'setCountryErrorMessage4Profile':
//     //   return {
//     //     ...state,
//     //     countryErrorMessage4Profile: action.payload, // Update the selected book
//     //   };

//     // case 'setEmail4Profile':
//     //   return {
//     //     ...state,
//     //     email4Profile: action.payload, // Update the selected book
//     //   };
//     // case 'setEmailError4Profile':
//     //   return {
//     //     ...state,
//     //     emailError4Profile: action.payload, // Update the selected book
//     //   };
//     // case 'setEmailErrorMessage4Profile':
//     //   return {
//     //     ...state,
//     //     emailErrorMessage4Profile: action.payload, // Update the selected book
//     //   };

//     // case 'setUsername4Profile':
//     //   return {
//     //     ...state,
//     //     username4Profile: action.payload, // Update the selected book
//     //   };
//     // case 'setUsernameError4Profile':
//     //   return {
//     //     ...state,
//     //     usernameError4Profile: action.payload, // Update the selected book
//     //   };
//     // case 'setUsernameErrorMessage4Profile':
//     //   return {
//     //     ...state,
//     //     usernameErrorMessage4Profile: action.payload, // Update the selected book
//     //   };

//     // case 'setPassword4Profile':
//     //   return {
//     //     ...state,
//     //     password4Profile: action.payload, // Update the selected book
//     //   };
//     // case 'setPasswordError4Profile':
//     //   return {
//     //     ...state,
//     //     passwordError4Profile: action.payload, // Update the selected book
//     //   };
//     // case 'setPasswordErrorMessage4Profile':
//     //   return {
//     //     ...state,
//     //     passwordErrorMessage4Profile: action.payload, // Update the selected book
//     //   };

//     // case 'setPasswordRetype4Profile':
//     //   return {
//     //     ...state,
//     //     passwordRetype4Profile: action.payload, // Update the selected book
//     //   };
//     // case 'setPasswordRetypeError4Profile':
//     //   return {
//     //     ...state,
//     //     passwordRetypeError4Profile: action.payload, // Update the selected book
//     //   };
//     // case 'setPasswordRetypeErrorMessage4Profile':
//     //   return {
//     //     ...state,
//     //     passwordRetypeErrorMessage4Profile: action.payload, // Update the selected book
//     //   };      
//     case 'setBookReadLogToBeCleared':
//       return {
//         ...state,
//         bookReadLogToBeCleared: action.payload, // Update the selected book
//       };    
//     case 'setEmailExisted':
//       return {
//         ...state,
//         emailExisted: action.payload, // Update the selected book
//       };
//     case 'setUsernameExisted':
//       return {
//         ...state,
//         usernameExisted: action.payload, // Update the selected book
//       };
//     case 'setLastNameOverMaxLength':
//       return {
//         ...state,
//         lastNameOverMaxLength: action.payload, // Update the selected book
//       };
//     case 'setFirstNameOverMaxLength':
//       return {
//         ...state,
//         firstNameOverMaxLength: action.payload, // Update the selected book
//       };

//     case 'reset4Profile':
//       return initialState;     
//     default:
//       return state;

//   }

// }

// export const setUserListItemToBeChanged = (e) => ({
//   type: 'setUserListItemToBeChanged',
//   payload: e,
// });

// // export const updateField = (e) => ({
// //   type: 'updateField',
// //   payload: e,
// // });

// // export const setField1 = (e) => ({
// //   type: 'setField1',
// //   payload: e,
// // });

// // export const setProfileToBeChanged = (e) => ({
// //   type: 'setProfileToBeChanged',
// //   payload: e,
// // });

// // export const setLastName4Profile = (e) => ({
// //   type: 'setLastName4Profile',
// //   payload: e,
// // });
// // export const setLastNameError4Profile = (e) => ({
// //   type: 'setLastNameError4Profile',
// //   payload: e,
// // });
// // export const setLastNameErrorMessage4Profile = (e) => ({
// //   type: 'setLastNameErrorMessage4Profile',
// //   payload: e,
// // });

// // export const setFirstName4Profile = (e) => ({
// //   type: 'setFirstName4Profile',
// //   payload: e,
// // });
// // export const setFirstNameError4Profile = (e) => ({
// //   type: 'setFirstNameError4Profile',
// //   payload: e,
// // });
// // export const setFirstNameErrorMessage4Profile = (e) => ({
// //   type: 'setFirstNameErrorMessage4Profile',
// //   payload: e,
// // });

// // export const setAgeRange4Profile = (e) => ({
// //   type: 'setAgeRange4Profile',
// //   payload: e,
// // });
// // export const setAgeRangeError4Profile = (e) => ({
// //   type: 'setAgeRangeError4Profile',
// //   payload: e,
// // });
// // export const setAgeRangeErrorMessage4Profile = (e) => ({
// //   type: 'setAgeRangeErrorMessage4Profile',
// //   payload: e,
// // });

// // export const setGender4Profile = (e) => ({
// //   type: 'setGender4Profile',
// //   payload: e,
// // });
// // export const setGenderError4Profile = (e) => ({
// //   type: 'setGenderError4Profile',
// //   payload: e,
// // });
// // export const setGenderErrorMessage4Profile = (e) => ({
// //   type: 'setGenderErrorMessage4Profile',
// //   payload: e,
// // });

// // export const setCountry4Profile = (e) => ({
// //   type: 'setCountry4Profile',
// //   payload: e,
// // });
// // export const setCountryError4Profile = (e) => ({
// //   type: 'setCountryError4Profile',
// //   payload: e,
// // });
// // export const setCountryErrorMessage4Profile = (e) => ({
// //   type: 'setCountryErrorMessage4Profile',
// //   payload: e,
// // });

// // export const setEmail4Profile = (e) => ({
// //   type: 'setEmail4Profile',
// //   payload: e,
// // });
// // export const setEmailError4Profile = (e) => ({
// //   type: 'setEmailError4Profile',
// //   payload: e,
// // });
// // export const setEmailErrorMessage4Profile = (e) => ({
// //   type: 'setEmailErrorMessage4Profile',
// //   payload: e,
// // });

// // export const setUsername4Profile = (e) => ({
// //   type: 'setUsername4Profile',
// //   payload: e,
// // });
// // export const setUsernameError4Profile = (e) => ({
// //   type: 'setUsernameError4Profile',
// //   payload: e,
// // });
// // export const setUsernameErrorMessage4Profile = (e) => ({
// //   type: 'setUsernameErrorMessage4Profile',
// //   payload: e,
// // });

// // export const setPassword4Profile = (e) => ({
// //   type: 'setPassword4Profile',
// //   payload: e,
// // });
// // export const setPasswordError4Profile = (e) => ({
// //   type: 'setPasswordError4Profile',
// //   payload: e,
// // });
// // export const setPasswordErrorMessage4Profile = (e) => ({
// //   type: 'setPasswordErrorMessage4Profile',
// //   payload: e,
// // });

// // export const setPasswordRetype4Profile = (e) => ({
// //   type: 'setPasswordRetype4Profile',
// //   payload: e,
// // });
// // export const setPasswordRetypeError4Profile = (e) => ({
// //   type: 'setPasswordRetypeError4Profile',
// //   payload: e,
// // });
// // export const setPasswordRetypeErrorMessage4Profile = (e) => ({
// //   type: 'setPasswordRetypeErrorMessage4Profile',
// //   payload: e,
// // });
// //setBookReadLogToBeCleared
// export const setBookReadLogToBeCleared = (e) => ({
//   type: 'setBookReadLogToBeCleared',
//   payload: e,
// });
// export const setEmailExisted = (e) => ({
//   type: 'setEmailExisted',
//   payload: e,
// });
// export const setUsernameExisted = (e) => ({
//   type: 'setUsernameExisted',
//   payload: e,
// });
// export const setLastNameOverMaxLength = (e) => ({
//   type: 'setLastNameOverMaxLength',
//   payload: e,
// });
// export const setFirstNameOverMaxLength = (e) => ({
//   type: 'setFirstNameOverMaxLength',
//   payload: e,
// });

// export const reset4Profile  = (e) => ({
//   type: 'reset4Profile',
//   payload: e,
// });